<template>
      <span style="flex: 1; display: flex; align-items: center; font-size: 14px; padding-right: 8px;">
        <span @click="WatchInfo(STORE,DATA,NODE)" style="width: 80%">
          <span>{{DATA.deptName}}</span>
        </span>
        <span class="span_icon">
          <el-button style="font-size: 12px;" type="text" v-if="DATA.dLevel < 3" @click="Append(STORE,DATA,NODE)">
            <i class="iconfont hohofast-xinzeng"></i>
          </el-button>
          <el-button style="font-size: 12px;" type="text" v-if="DATA.dLevel !== 0" @click="Edit(STORE,DATA,NODE)">
            <i class="iconfont hohofast-modify"></i>
          </el-button>
          <el-button style="font-size: 12px;" type="text" v-if="DATA.children == ''" @click="Delete(STORE,DATA,NODE)">
            <i class="iconfont hohofast-shanchu"></i>
          </el-button>
        </span>
      </span>
</template>

<script>
  export default {
    name: '',
    data() {
        return {}
    },
    props: ['NODE', 'DATA', 'STORE'],
    methods:{
      Append(s,d,n){
        //添加节点事件
        this.$emit('Append',s,d,n)
      },
      Edit(s,d,n){
        //添加节点事件
        this.$emit('Edit',s,d,n)
      },
      Delete(s,d,n){
        this.$emit('Delete',s,d,n)
      },
      WatchInfo(s,d,n){
        this.$emit('WatchInfo',s,d,n)
      }  
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// tree_render_new.vue?47e4dca0